"use client";

import React from "react";
import Button from "@/components/ui/Button";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { CarouselPreviousProps } from "../types";
import { useCarouselStore } from "./carousel-provider";

function CarouselPrevious({
  variant = "outline",
  size = "icon",
  icon = "chevron-left",
  "aria-label": ariaLabel = "Previous label",
  className = "",
  ...props
}: CarouselPreviousProps) {
  const canScrollPrev = useCarouselStore(state => state.canScrollNext);
  const scrollPrev = useCarouselStore(state => state.scrollPrev);

  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  const handleOnClick = React.useCallback(() => {
    scrollPrev();
  }, [scrollPrev]);

  return (
    <Button.Icon
      variant={variant}
      size={size}
      icon={icon}
      className={cn(className, classes)}
      disabled={!canScrollPrev}
      onClick={handleOnClick}
      data-slot="carousel-previous"
      aria-label={ariaLabel}
      {...native}
    />
  );
}

export default CarouselPrevious;
